<template>
  <div class="color">
    <div :class="`${!useAlpha ? 'remove-alpha' : ''} box`" :style="`background-color: ${color}`" @click="open">
      <ColorPicker :value="color" v-if="opened" @input="colorPickerInput" v-click-outside="close" />
    </div>
    <FormInput class="" :value="hex" @input="inputValue('hex', $event)" v-if="!noInput" />
  </div>
</template>

<script>
import validateColor from 'validate-color';
import ChromePicker from 'vue-color/src/components/Chrome';

export default {
  components: {
    ColorPicker: ChromePicker,
  },
  props: {
    value: { type: String, default: '#FFFFFF' },
    returnRGB: { type: Boolean, default: false },
    noInput: { type: Boolean, default: false },
  },
  methods: {
    inputValue(type, value) {
      this[type] = value;
      this.emit();
    },
    close() {
      this.opened = false;
    },
    open() {
      setTimeout(() => {
        this.opened = true;
      }, 100);
    },
    colorPickerInput({ hex, a, rgba: { r, g, b } }) {
      this.hex = hex;
      this.alpha = Math.round(a * 100) / 100;
      this.rgb = `${r},${g},${b}`;
      this.emit();
    },
    emit() {
      if (this.returnRGB) {
        this.color = this.hex;
        this.$emit('color', this.rgb);
        return;
      }

      const color = `${this.hex}${this.convertAlpha(this.alpha)}`;
      if (validateColor(color)) {
        this.color = color;
        this.$emit('color', color);
      }
    },
    convertAlpha(alpha) {
      return `${alpha}` === '0' || `${alpha}` === '00' || `${alpha}` === '0,0' || `${alpha}` === '0.0' ? '00' : Math.round(Math.min(Math.max(alpha || 1, 0), 1) * 255).toString(16).toUpperCase();
    },
    hexAtoFloat(hex) {
      return Math.round(+(`0x${hex[7]}${hex[8]}` / 255) * 100) / 100;
    },
    componentToHex(c) {
      const hex = c.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    },
    rgbToHex(r, g, b) {
      return `#${this.componentToHex(r)}${this.componentToHex(g)}${this.componentToHex(b)}`;
    },
  },
  data() {
    return {
      hex: '#FFFFFF',
      rgb: '',
      alpha: 1,
      color: '',
      opened: false,
      useAlpha: false,
    };
  },
  mounted() {
    console.log(this.value);
    if (this.value) {
      if ((this.value.match(/,/g) || []).length === 2) {
        const rgb = this.value.split(',');
        this.color = this.rgbToHex(parseInt(rgb[0], 10), parseInt(rgb[1], 10), parseInt(rgb[2], 10));
        this.hex = this.color;
      } else {
        this.hex = this.value.substring(0, 7);
        if (this.value.length === 9) {
          this.useAlpha = true;
          this.alpha = this.hexAtoFloat(this.value);
        }

        this.color = !this.useAlpha ? this.hex : this.value;
      }
    }
  },
};
</script>

<style lang="scss">
.color {
  .input {
    width: 100%;

    input {
      min-height: 27px;
      font: 12px/18px 'Fira mono', monospace;
      padding: 11px 10px;
      font-size: 16px;
    }
  }

  .box {
    border: 1px solid #B7BDC6;
    border-radius: 7px;
    cursor: pointer;
    height: 42px;
    position: relative;
    width: 42px;

    .vc-chrome {
      position: absolute;
      left: 50%;
      top: 70%;
      z-index: 1;
      transform: translateX(-50%);
    }

    &.remove-alpha {
      .vc-chrome-alpha-wrap {
        display: none;
      }
      .vc-chrome-hue-wrap {
        margin-top: 9px;
      }
    }
  }
}
</style>
